import React from "react";
import { useTranslation } from 'react-i18next';
import houseImg from "assets/NotFound.svg";

const NotFound = () => {
    const { t } = useTranslation();
  return (
    <div>
      <div className="d-flex justify-content-center my-5 text-center">
        <div>
          <h4 className="text-secondary">{t("not-found1")}.</h4>
          <img src={houseImg} width={300} alt="not found image" />
          <h4 className="pt-3 text-secondary">
          {t("not-found2") }  <a className="text-decoration-underline link-cstm" href="/">{t("home")}</a>
          </h4>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
